import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {

  return (
    <p>
      <Link to="/"> Kidakupo </Link>
      <span className="highlight"> Eat the world raw. </span>
    </p>
  )
}

export default Header